/* eslint-disable react/prop-types */
import React from 'react'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { CSpinner } from '@coreui/react'
import { ssoLogin } from 'src/redux/slices/bootStrapSlice'
import { setAuthToken } from 'src/services/api'
// import History from 'src/@history'
const Bootstrap = ({ children }) => {
  const dispatch = useDispatch()

  const bearerToken = useSelector((state) => state?.bootstrap?.data?.token)
  const { loading, countryCode } = useSelector((state) => state.bootstrap)
  const { orderBy } = useSelector((state) => state.transaction.advanceSearch)

  const token = sessionStorage.getItem('syngentaAdminToken')
  // Bootstraping the country admin token at the beginning of the app load
  useEffect(() => {
    if (token) {
      dispatch(ssoLogin({ idToken: token }))
    }
  }, [dispatch, token, orderBy, countryCode])

  useEffect(() => {
    if (bearerToken) {
      setAuthToken(bearerToken)
    }
  }, [bearerToken])

  if (loading)
    return (
      <div
        style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}
      >
        <CSpinner data-testid="UT-Loader" variant="grow" />
      </div>
    )
  return children
}

export default Bootstrap
